// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6c147d8a","732":"25ff16fb","977":"70f8bab2"}[chunkId] + ".chunk.js";
};